import { lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Login } from '../pages/Login/Login';
import { NotFound } from '../pages/NotFound';
import { useAuth } from '../hooks/auth';
import { Theme } from '../components/Theme/Theme';
import { FormProvider } from '../contexts/FormContext';
import { ScrollToTop } from '../components/ScrollToTop/ScrollToTop';
import { LazyPage } from '../components/lazy-page';

const CreateUser = lazy(() =>
  import('../pages/CreateUser').then((m) => ({ default: m.CreateUser }))
);
const FormStep2 = lazy(() =>
  import('../pages/FormStep2').then((m) => ({ default: m.FormStep2 }))
);
const FormStep3 = lazy(() =>
  import('../pages/FormStep3').then((m) => ({ default: m.FormStep3 }))
);
const FormStep4 = lazy(() =>
  import('../pages/FormStep4').then((m) => ({ default: m.FormStep4 }))
);
const FormStep5 = lazy(() =>
  import('../pages/FormStep5').then((m) => ({ default: m.FormStep5 }))
);
const FormStep6 = lazy(() =>
  import('../pages/FormStep6').then((m) => ({ default: m.FormStep6 }))
);
const FormStep7 = lazy(() =>
  import('../pages/FormStep7').then((m) => ({ default: m.FormStep7 }))
);
const FormStep8 = lazy(() =>
  import('../pages/FormStep8').then((m) => ({ default: m.FormStep8 }))
);
const FormStep9 = lazy(() =>
  import('../pages/FormStep9').then((m) => ({ default: m.FormStep9 }))
);
const FormStep10 = lazy(() =>
  import('../pages/FormStep10').then((m) => ({ default: m.FormStep10 }))
);
const FormStep11 = lazy(() =>
  import('../pages/FormStep11').then((m) => ({ default: m.FormStep11 }))
);
const FormStep12 = lazy(() =>
  import('../pages/FormStep12').then((m) => ({ default: m.FormStep12 }))
);
const FormStep13 = lazy(() =>
  import('../pages/FormStep13').then((m) => ({ default: m.FormStep13 }))
);
const FormStep14 = lazy(() =>
  import('../pages/FormStep14').then((m) => ({ default: m.FormStep14 }))
);
const FormStep15 = lazy(() =>
  import('../pages/FormStep15').then((m) => ({ default: m.FormStep15 }))
);
const ForgotPass = lazy(() =>
  import('../pages/ForgotPass').then((m) => ({ default: m.ForgotPass }))
);
const SeeData = lazy(() =>
  import('../pages/SeeData').then((m) => ({ default: m.SeeData }))
);
const SubscriptionView = lazy(() =>
  import('../pages/subscription-view').then((m) => ({
    default: m.SubscriptionView,
  }))
);
const UpdatePass = lazy(() =>
  import('../pages/UpdatePass').then((m) => ({ default: m.UpdatePass }))
);
const Initial = lazy(() =>
  import('../pages/Initial/Initial').then((m) => ({ default: m.Initial }))
);
const Profile = lazy(() =>
  import('../pages/Profile').then((m) => ({ default: m.Profile }))
);

export const RoutesApp: React.FC = () => {
  const { user } = useAuth();

  function Auth({ children }: { children: JSX.Element }) {
    let location = useLocation();

    if (!user) {
      return <Navigate to='/' state={{ from: location }} replace />;
    }
    return children;
  }

  return (
    <FormProvider>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Login />} />
        <Route
          path='/recupera-senha'
          element={
            <LazyPage>
              <ForgotPass />
            </LazyPage>
          }
        />
        <Route
          path='/altera-senha'
          element={
            <LazyPage>
              <UpdatePass />
            </LazyPage>
          }
        />
        <Route
          path='/cadastro'
          element={
            <Theme>
              <LazyPage>
                <CreateUser />
              </LazyPage>
            </Theme>
          }
        />
        <Route
          path='/initial'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <Initial />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo2'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep2 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo3'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep3 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo4'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep4 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo5'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep5 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo6'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep6 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo7'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep7 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo8'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep8 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo9'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep9 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo10'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep10 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo11'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep11 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo12'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep12 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo13'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep13 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/passo14'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep14 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/concluido'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <FormStep15 />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/dados-inscricao'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <SeeData />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/dados-inscricao/:id'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <SubscriptionView />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route
          path='/perfil'
          element={
            <Auth>
              <Theme>
                <LazyPage>
                  <Profile />
                </LazyPage>
              </Theme>
            </Auth>
          }
        />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </FormProvider>
  );
};
